
    <app-header></app-header>
    <div class="onboarding-in-process-container">
        <div class="onboarding-in-process-content">
            <mat-icon class="svg-pending-steps" svgIcon="fd-review"></mat-icon>
            <h2 class="pending-alert" i18n>
                Your onboarding is currently in progress.
            </h2>

            <p class="contact-text">
                If you have any questions, please contact
                <a href="mailto:onboarding@frauddeflect.com">onboarding&#64;frauddeflect.com</a>.
            </p>
        </div>
    </div>
